import React from 'react';
import { RootElement } from './src/templates/RootElement';

export const wrapRootElement = ({ element }) => {
    return <RootElement>{element}</RootElement>;
};
